var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"c-input c-input-radio"},[_c('div',{staticClass:"c-input-radio-ct"},[_c('input',{attrs:{"id":_vm.id,"name":_vm.name,"type":"radio"},domProps:{"value":_vm.label}}),_vm._v(" "),_c('label',{staticClass:"c-input-radio-label",attrs:{"for":_vm.id}},[_vm._v(_vm._s(_vm.label))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }